export const FEATURE_TOGGLE_KEYS = {
  PTP_EVENT_VISIBILITY: 'ptp_event_visibility',
  RETURN_MANAGEMENT: 'return_management',
  CAMPAIGN_MANAGER: 'campaign_manager',
};
